import React from 'react'
import {Link} from 'react-router-dom'


export const CocktailList = ({cocktail,showId}) => {


  return (
    <div className=' grid lg:grid-cols-3 md:grid-cols-1 gap-5 m-1'>
      {cocktail?.map((item,idx)=>{
          return (
            <div key={idx} >
              <div>
                <Link to='/cocktail'  >
                  <h1>{item.strDrink}</h1> 
                  <img alt='-' src={item.strDrinkThumb} className='card-container rounded-xl border-none cursor-pointer' onClick={()=>showId(idx)}/>
                </Link>
              </div>
               {/* <div>
                <h5>{item.strDrink} Ingredients</h5>
                <hr/>
                <div style={{fontSize:'70%',fontFamily:'fantasy'}}>
                  <ul>
                    <li>{item.strIngredient1}</li>
                    <li>{item.strIngredient2}</li>
                    <li>{item.strIngredient3}</li>
                  </ul>
                </div>
              </div>  */}
                 <hr/>
                 <hr/>
                 <hr/>   
            </div>
            )   
      })}
    </div>
  )
}
